<template>
<div class="page-login">
    <div class="container">

            <h2>A melhor forma de navegar na internet</h2>

            <div class="page-login-header">

                <div class="field has-addons has-addons-centered">

                    <div class="control"><button class="button" :class="{'is-primary':action=='login'}" @click="action='login'"> Entrar </button></div>
                    <div class="control"><button class="button" :class="{'is-primary':action=='signup'}" @click="action='signup'"> Registrar </button></div>

                </div>
            </div>

            <div class="page-login-body" v-if="action=='signup'">

                <form @submit.prevent="onSubmit">
                    <div class="field">
                        <div class="control">
                            <input type="text" class="input" v-model="name" placeholder="Nome completo" required>
                        </div>
                    </div>
                    <div class="field">
                        <div class="control">
                            <input type="email" class="input" v-model="email" placeholder="E-mail" required>
                        </div>
                    </div>
                    <div class="field">
                        <div class="control">
                            <input type="password" class="input" v-model="password" placeholder="Senha" required>
                        </div>
                    </div>
                    <div class="field field-aceite">
                        <div class="control">
                            <label><input type="checkbox" v-model="aceito_politica"> Li e concordo. <router-link to="politica-de-privacidade">Política de privacidade</router-link></label>
                        </div>
                        <div class="control">
                            <label><input type="checkbox" v-model="aceito_termos"> Li e concordo. <router-link to="termos-e-condicoes">Termos e condições de uso</router-link></label>
                        </div>
                    </div>
                    <div class="field">
                        <button class="button is-primary">Registrar</button>
                    </div>
                </form>
                <hr>

                <div class="field social-login">
                    <div class="field-body">
                        <div class="field">


                            <div class="control">
                                <div class="button is-dark button-google" @click="onSignupGoogle">
                                    <span class="icon"> <svg style="width:24px;height:24px" viewBox="0 0 24 24"> <path fill="#fff" d="M21.35,11.1H12.18V13.83H18.69C18.36,17.64 15.19,19.27 12.19,19.27C8.36,19.27 5,16.25 5,12C5,7.9 8.2,4.73 12.2,4.73C15.29,4.73 17.1,6.7 17.1,6.7L19,4.72C19,4.72 16.56,2 12.1,2C6.42,2 2.03,6.8 2.03,12C2.03,17.05 6.16,22 12.25,22C17.6,22 21.5,18.33 21.5,12.91C21.5,11.76 21.35,11.1 21.35,11.1V11.1Z" /> </svg> </span>
                                    <span>Registrar com o Google</span>
                                </div>
                            </div>

                        </div>
                        <div class="field">
                            <div class="control">
                                <div class="button is-dark button-facebook" @click="onSignupFacebook">
                                    <span class="icon"> <svg style="width:24px;height:24px" viewBox="0 0 24 24"> <path fill="#fff" d="M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6A4,4 0 0,1 14,2H17Z" /> </svg> </span>
                                    <span>Registrar com o Facebook</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


            </div>

            <div class="page-login-body" v-if="action=='login'">
                <form @submit.prevent="onSubmitLogin">
                    <div class="field">
                        <div class="control">
                            <input type="email" class="input" v-model="email" placeholder="E-mail" required>
                        </div>
                    </div>
                    <div class="field">
                        <div class="control">
                            <input type="password" class="input" v-model="password" placeholder="Senha" required>
                        </div>
                    </div>
                    <div class="field">
                        <p class="control">
                            <a @click="action='forget'">Esqueci minha senha</a>
                        </p>
                    </div>
                    <div class="field">
                        <button class="button is-primary">Avançar</button>
                    </div>
                </form>

                <hr>

                <div class="field social-login">
                    <div class="field-body">

                        <div class="field">

                            <div class="control">
                                <div class="button is-dark button-google" @click="onSignupGoogle">
                                    <span class="icon"> <svg style="width:24px;height:24px" viewBox="0 0 24 24"> <path fill="#fff" d="M21.35,11.1H12.18V13.83H18.69C18.36,17.64 15.19,19.27 12.19,19.27C8.36,19.27 5,16.25 5,12C5,7.9 8.2,4.73 12.2,4.73C15.29,4.73 17.1,6.7 17.1,6.7L19,4.72C19,4.72 16.56,2 12.1,2C6.42,2 2.03,6.8 2.03,12C2.03,17.05 6.16,22 12.25,22C17.6,22 21.5,18.33 21.5,12.91C21.5,11.76 21.35,11.1 21.35,11.1V11.1Z" /> </svg> </span>
                                    <span>Login com o Google</span>
                                </div>
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <div class="button is-dark button-facebook" @click="onSignupFacebook">
                                    <span class="icon"> <svg style="width:24px;height:24px" viewBox="0 0 24 24"> <path fill="#fff" d="M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6A4,4 0 0,1 14,2H17Z" /> </svg> </span>
                                    <span>Login com o Facebook</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="page-login-body" v-if="action=='forget'">

                <form @submit.prevent="onSubmitForget">
                    <p class="field">Informe o seu e-mail de cadastro para recuperar a senha de acesso.</p>
                    <div class="field">
                        <div class="control">
                            <input type="email" class="input" v-model="email" placeholder="E-mail" required>
                        </div>
                    </div>
                    <div class="field">
                        <button class="button is-primary">Enviar</button>
                    </div>
                </form>


            </div>
            <div class="page-login-body" v-if="action=='sent'">

                <form>
                    <p class="field">E-mail enviado com sucesso.</p>
                    <div class="field">
                        <button class="button is-primary" @click="action='login'">Voltar para o login</button>
                    </div>
                </form>


            </div>

            <figure class="ilustracao">
                <img src="images/ilustracao-caixas-login.png">
            </figure>



        </div>
    </div>

</template>
<style>

    .page-login {
      text-align: center;
      padding:40px 20px;
      min-height: calc(100vh - 82px);
      background: url(../../public/images/bg2020-01-29.jpg) no-repeat center #000;;
      background-size: cover;
  }
    .page-login h2 {
        color:#fff;
        text-shadow: 1px 1px 5px rgba(0,0,0,.5);
        font-size: 32px;
        margin-bottom: 40px;

    }
    .page-login-header { max-width: 550px; margin: 0 auto 20px;}
    .page-login-header .control { width:100%; }
    .page-login-header .button { width:100%; }
    .page-login-body h3 { color:#fff;}
    .page-login-body form { width:100%; max-width:550px; margin: 0 auto;}
    .page-login-body .button { width:240px; }


    .page-login hr { margin: 20px auto; height: 1px; max-width: 550px;}

    .button.button-facebook { background: #3A559F; width:240px; }
    .button.button-google { background: #D62222; width:240px; }

    .field-aceite {color:#fff;}
    .field-aceite a {text-decoration: underline;}
    .page-login a { color:#fff; }
    .page-login a:hover {text-decoration: underline; }

    .page-login-body .social-login  { width:100%; max-width:550px; margin: 0 auto; }
    .page-login-body .social-login .control  { text-align: center;}

    .page-login .ilustracao  {
        margin: 100px auto 0;
        text-align: center;
        max-width: 650px;
    }
    .page-login .ilustracao img {}

    @media ( min-width:992px) {
        .field-aceite { margin-left:120px; }
    }

    @media ( max-width:991px) {
        .page-login {background-attachment: fixed;
            min-height: calc(100vh - 40px);
        }

        .page-login h2 { font-size: 18px; margin-bottom:30px; }
        .page-login .ilustracao  {margin: 60px auto 0; }
    }


</style>
<script>

    /* eslint-disable no-console */
    import firebase from 'firebase';
    export default {
        name: 'signup',
        data(){
            return {
                action:'login',
                name:'',
                email:'',
                password:'',
                aceito_politica:false,
                aceito_termos:false,
            }
        },
        methods: {
            onSubmit(){
                if(!this.aceito_politica){
                    alert('Para avançar, é preciso concordar com os termos e condições de uso e com nossa política de privacidade.');
                    return false;
                }
                if(!this.aceito_termos){
                    alert('Para avançar, é preciso concordar com os termos e condições de uso e com nossa política de privacidade.');
                    return false;
                }
                this.$store.state.userName = this.name;

                var email = this.email;
                var password = this.password;
                if (email.length < 4) {
                    alert('Please enter an email address.');
                    return;
                }
                if (password.length < 4) {
                    alert('Please enter a password.');
                    return;
                }
                this.$store.dispatch('startLoading');
                firebase.auth().createUserWithEmailAndPassword(email, password).then((user)=>{
                    // var user = firebase.auth().currentUser;
                    // user.updateProfile({
                    //     displayName: this.firstName+' '+this.lastName
                    // })

                    this.$store.dispatch('stopLoading');
                }).catch((error) => {
                    this.$store.dispatch('stopLoading');
                    this.exibirErro(error.code,error.message);

                });

            },
            exibirErro(code,message){
                if(code=='auth/email-already-in-use'){
                    alert('Oops! Acesse o seu painel da mesma forma como se registrou (Google ou Facebook)');
                } else if(code=='auth/account-exists-with-different-credential') {
                    alert('Oops! Acesse o seu painel da mesma forma como se registrou (Google ou Facebook)');
                } else if(code=='auth/wrong-password') {
                    alert('Oops! E-mail ou senha incorretos.');
                } else if(code=='auth/user-not-found') {
                    alert('Oops! Este usuário ainda não é registrado. Por favor registre-se para acessar.');
                } else {
                    alert(code+' - '+message);
                }
            },
            onSubmitLogin(){
                var email = this.email;
                var password = this.password;
                this.$store.dispatch('startLoading');

                firebase.auth().signInWithEmailAndPassword(email, password).then(()=>{
                    this.$store.dispatch('stopLoading');
                }).catch((error) => {
                    this.$store.dispatch('stopLoading');
                    this.exibirErro(error.code,error.message);
                });
            },
            onSubmitForget(){

                var auth = firebase.auth();
                var emailAddress = this.email;

                this.$store.dispatch('startLoading');

                auth.sendPasswordResetEmail(emailAddress).then(() => {
                    this.$store.dispatch('stopLoading');
                    console.log('email sent');
                    console.log();

                    this.action='sent';
                }).catch((error) => {
                    this.$store.dispatch('stopLoading');
                    this.exibirErro(error.code,error.message);
                  // An error happened.
                });

            },
            onSignupGoogle () {
                if(this.action=='signup'){
                    if(!this.aceito_politica){
                        alert('Para avançar, é preciso concordar com os termos e condições de uso e com nossa política de privacidade.');
                        return false;
                    }
                    if(!this.aceito_termos){
                        alert('Para avançar, é preciso concordar com os termos e condições de uso e com nossa política de privacidade.');
                        return false;
                    }
                }
                this.$store.state.userFirstName = '';
                this.$store.state.userLastName = '';

                this.$store.dispatch('startLoading');
                var provider = new firebase.auth.GoogleAuthProvider();
                firebase.auth().languageCode = 'pt';
                firebase.auth().signInWithPopup(provider).then(()=>{
                    this.$store.dispatch('stopLoading');
                }).catch((error) => {
                    this.$store.dispatch('stopLoading');
                    this.exibirErro(error.code,error.message);
                });
            },
            onSignupFacebook () {
                if(this.action=='signup'){
                    if(!this.aceito_politica){
                        alert('Para avançar, é preciso concordar com os termos e condições de uso e com nossa política de privacidade.');
                        return false;
                    }
                    if(!this.aceito_termos){
                        alert('Para avançar, é preciso concordar com os termos e condições de uso e com nossa política de privacidade.');
                        return false;
                    }
                }
                this.$store.state.userFirstName = '';
                this.$store.state.userLastName = '';
                this.$store.dispatch('startLoading');
                var provider = new firebase.auth.FacebookAuthProvider();
                firebase.auth().signInWithPopup(provider).then(()=>{
                    this.$store.dispatch('stopLoading');
                }).catch((error) => {
                    this.$store.dispatch('stopLoading');
                    this.exibirErro(error.code,error.message);
                });
            },
        },
        activated(){
            console.log('window.location.hash',window.location.hash)
            if(window.location.hash == '#registrar'){
                this.action='signup'
            }
            //this.$store.dispatch('stopLoading');
        }
    }
</script>
